<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :loading="loading" :toPdf="eleToPdf"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'ExclusiveData',
    components: { MulReportHeader },
    data() {
        return {
            TransTopReqTimer: null,
            loading: false,
            table: {
                params: {
                    platids: [],
                    app_id: 0,
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    { type: 'index', title: '序号', align: 'center', width: 60 },
                    { key: 'app_name', width: 90, align: 'center', renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称') },
                    {
                        key: 'total_point',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '总转入', '统计盘口筛选时间内的转入金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.total_point / 10000))
                    },
                    this.renderPointCol('ten_point', '专享10%支付方式转入量占比大盘', '专享10%支付方式转入量占比大盘'),
                    {
                        key: 'ten_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '专享10%支付方式转入次数占比大盘', '专享10%支付方式转入次数占比大盘'),
                        render: (h, params) => h('span', this.getRate(params.row.ten_num, params.row.total_num))
                    },
                    this.renderPointCol('vip_point', '公司入账占比大盘', '统计盘口筛选时间内的公司入账占比大盘'),
                    this.renderPointCol('scan_point', '扫码占比大盘', '统计盘口筛选时间内的扫码占比大盘'),
                    this.renderPointCol('bank_card_point', '银行卡支付占比大盘', '统计盘口筛选时间内银行卡支付占比大盘'),
                    this.renderPointCol('yun_point', '云闪付占比大盘', '统计盘口筛选时间内云闪付占比大盘'),
                    this.renderPointCol('union_point', '银联占比大盘', '统计盘口筛选时间内银联占比大盘')
                ]
            }
        }
    },
    methods: {
        async toHttp(httpList, all, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                TransTopReq(param).then((tData) => {
                    let data = tData._param
                    data.app_name = param.app_name
                    all.total_point += data.total_point
                    all.total_num += data.total_num
                    all.ten_point += data.ten_point
                    all.vip_point += data.vip_point
                    all.scan_point += data.scan_point
                    all.union_point += data.union_point
                    all.yun_point += data.yun_point
                    all.ten_num += data.ten_num
                    all.bank_card_point += data.bank_card_point

                    this.table.data.pop()
                    let result = [...this.table.data, data]
                    result.sort((a, b) => {
                        let resultA = a.total_point == 0 ? 0 : a.ten_point / a.total_point
                        let resultB = b.total_point == 0 ? 0 : b.ten_point / b.total_point
                        return resultA > resultB ? -1 : 1
                    })
                    result.push(all)
                    this.table.data = result
                    loadingArr.shift()
                    if (loadingArr.length == 0) this.closeTimer()
                    this.toHttp(httpList, all, loadingArr)
                })
            }
        },
        renderPointCol(key, title, tip) {
            return {
                key,
                minWidth: 80,
                align: 'center',
                renderHeader: (h) => this.renderHeader(h, title, tip),
                render: (h, params) => h('span', this.getRate(params.row[key], params.row.total_point))
            }
        },
        getRate(val1, val2) {
            return (val2 ? (val1 / val2) * 100 : 0 || 0).toFixed(2) + '%'
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: { ...param }
                }
            }
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        },
        getCompColor(val) {
            return val > 0 ? 'red' : val < 0 ? '#32CD32' : 'black'
        },
        getTrendIcon(h, value) {
            if (!value) return
            return h('Icon', {
                props: {
                    type: value < 0 ? 'md-arrow-down' : 'md-arrow-up',
                    color: value < 0 ? '#32CD32' : 'red',
                    size: 16
                },
                style: {
                    marginLeft: '4px'
                }
            })
        },
        //查询数据
        searchData(emitProps) {
            if (this.loading) return
            let allList = this.getAllHttpAppid(this.table.params)
            this.table.data = []
            let all = { app_id: -10, plat_form_name: '', app_name: '合计', total_point: 0, ten_point: 0, scan_point: 0, total_num: 0, union_point: 0, yun_point: 0, ten_num: 0, bank_card_point: 0, vip_point: 0 }
            let httpList = []
            let loadingArr = [...allList]
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                let app_name = item.appName
                let platid = item.platform
                let param = this.getTransTopParams('GetUserPayNameData', { type: 0, platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 })
                httpList.push(param)
            }
            this.openTimer()
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, all, loadingArr)
            }
        }
    }
}
</script>

<style scoped lang="less"></style>
